import script from "./rich-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./rich-editor.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__